import type React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Container from '@zg-rentals/multibrand-ui/lib/Container';
import Row from '@zg-rentals/multibrand-ui/lib/Row';
import Col from '@zg-rentals/multibrand-ui/lib/Col';

interface Props {
  propertyId: string;
}

const FindNewRenterScreen: React.FC<React.PropsWithChildren<Props>> = ({ propertyId }) => {
  const goToListingPage = (): void => {
    window.location.href =
      `/rental-manager/properties/${propertyId}/listing?` + 'itc=Payment_Term_Completed_Modal_Post&acceptTerms=true';
  };
  const goToLearnMorePage = (): void => {
    window.location.href =
      '/rental-manager/post-a-listing?itc=Payment_Term_Completed_Modal_LearnMore' + '&acceptTerms=true';
  };

  return (
    <Container>
      <Row>
        <Col>
          <Text type="h3">Find a new renter</Text>
          <Text>We&apos;ll help you list your rental on Zillow, Trulia and Hotpads.</Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button full type="primary" className="noUnderLine" onClick={goToListingPage}>
            Get started
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button full type="tertiary" className="noUnderLine" onClick={goToLearnMorePage}>
            Learn more
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FindNewRenterScreen;
